var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75638 2.66489H2.64468C2.20848 2.66489 1.79015 2.83817 1.48172 3.14661C1.17328 3.45504 1 3.87338 1 4.30957V13.3553C1 13.7915 1.17328 14.2098 1.48172 14.5183C1.79015 14.8267 2.20848 15 2.64468 15H11.6904C12.1266 15 12.545 14.8267 12.8534 14.5183C13.1618 14.2098 13.3351 13.7915 13.3351 13.3553V9.24362M12.1723 1.5021C12.324 1.34502 12.5055 1.21972 12.7062 1.13353C12.9068 1.04733 13.1226 1.00196 13.341 1.00006C13.5594 0.998164 13.776 1.03978 13.9781 1.12247C14.1802 1.20517 14.3639 1.32729 14.5183 1.48172C14.6727 1.63614 14.7948 1.81977 14.8775 2.0219C14.9602 2.22402 15.0018 2.44059 14.9999 2.65897C14.998 2.87735 14.9527 3.09317 14.8665 3.29383C14.7803 3.49448 14.655 3.67596 14.4979 3.82768L7.43728 10.8883H5.1117V8.56272L12.1723 1.5021Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftEdit);
export default __webpack_public_path__ + "static/media/shiftEdit.d6e78d572fbdb26f65399602139ed55f.svg";
export { ForwardRef as ReactComponent };